import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { saveSheetGuard } from 'src/app/angular-core/utils/guards/savesheet.guard';
import { authorizedGuard } from 'src/app/shared/guards/authorized.guard';
import { DeviceStateResolver } from 'src/app/shared/resolvers/device-state.resolver';
import { XpacInfoComponent } from './xpac-info/xpac-info.component';

const routes: Routes = [
  {
    path: 'xpac-info/:id',
    component: XpacInfoComponent,
    resolve: {
      currentDeviceData: DeviceStateResolver
    },   
    canDeactivate: [saveSheetGuard],
    canActivate: [authorizedGuard],
    data: { breadcrumb: 'Device settings', animation: 'xpac-info', showbackbutton: true, parent: 'service', parentFromRoot: true },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class XPACManagementRoutingModule { }
